import request from "../../Requests/requests";
import { loadSpentTimeResults } from "../../store/SpentTimeTask/SpentTimeReducer";
import getDateUTC from "../../utils/getDateUTC";

export const getSpentTime = () => {
    return async dispatch => {
        try {
            const response = await request.get('/Time/SpentTime', {params: {date: getDateUTC(), userId: localStorage.getItem('userID')}})
            const data = response.data
            dispatch(loadSpentTimeResults(data))
            return data;
        } catch (error) {
            return error;
        }}
    }